/*
 * @Author: Dong
 * @Date: 2022-04-07 13:40:11
 * @LastEditors: zhang lin
 * @LastEditTime: 2022-09-26 14:09:48
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  memory: '内存',
  tempSize: '临时储存空间',
  cpuLimitRequired: '请输入CPU',
  memLimitRequired: '请输入内存',
  storageLimitRequired: '请输入临时储存空间',
  java: '环境变量',
  sourceConfigSet: '服务资源配置',
  numFormat: '请输入正数字',
  memoryMin: '最小值不得小于4MB',
});
